import React from "react"
import {Avatar, Button, FormControl, FormLabel} from "@chakra-ui/react"

import {ILabelSet} from "@backend/types"
import {CatIcon} from "@components/app"
import {IconNameExt} from "@utils/icons"
import {Table} from "@components/elements"

import {labelHeaders} from "./LabelUpload"

type LabelSetTableProps = {
    labelSet: ILabelSet,
    onLabelSetRemove: () => void
}

export function LabelSetTable({labelSet, onLabelSetRemove}: LabelSetTableProps) {

    return <div className="space-y-6">
        <div>
            <FormControl>
                <FormLabel>Selected Label Set</FormLabel>
            </FormControl>
            <div className="flex items-center justify-between p-4 border rounded">
                <div className="flex min-w-0 items-center">
                    <Avatar
                        className="h-12 w-12 flex-none rounded-full bg-gray-50 mr-4"
                        bg={labelSet.color}
                        icon={<CatIcon
                            icon={labelSet.icon as IconNameExt || "blender"}
                            iconSize="lg"/>}/>
                    <p className="text-sm font-semibold leading-6 text-gray-900">{labelSet.title}</p>
                </div>
                <Button
                    colorScheme="red"
                    variant="ghost"
                    size="sm"
                    onClick={onLabelSetRemove}
                >Remove</Button>
            </div>
        </div>
        <div>
            <FormControl>
                <FormLabel>Selected Labels</FormLabel>
            </FormControl>
            <Table
                columns={Object.keys(labelHeaders).filter(x => !labelHeaders[x].hidden).map(key => ({
                    header: labelHeaders[key].title,
                    accessorKey: key,
                    enableColumnFilter: false,
                    enableSorting: false
                }))}
                data={labelSet.labelIds || []}
            />
        </div>
    </div>
}